/** External product / HMC app */
export const APP_URL = "https://app.rxn3d.com";

/** Canonical marketing site origin (use www; apex redirects and breaks OG images) */
export const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://www.rxn3d.com";
